import { getDPRSize } from 'common/components/RewindModal/helper';

export const BADGE_HEIGHT = getDPRSize(47.44);
export const BADGE_OFFSET_X = getDPRSize(44);
export const BADGE_OFFSET_Y = getDPRSize(67);
export const BADGE_WIDTH = getDPRSize(47.44);
export const BLOCKS_WIDTH = getDPRSize(304);
export const BLOCK_MARGIN = getDPRSize(16);
export const BRAND_LOGO_HEIGHT = getDPRSize(27);
export const BRAND_LOGO_OFFSET_Y = getDPRSize(722);
export const CARTRIDGE_CORNER_RADIUS = getDPRSize(20);
export const CARTRIDGE_GROUP_OFFSET_Y = getDPRSize(166);
export const CARTRIDGE_PADDING = getDPRSize(16);
export const CATEGORY_FONT_SIZE = getDPRSize(11);
export const CATEGORY_LINE_HEIGHT = 13 / 11;
export const CELEBRITY_HEIGHT = getDPRSize(156);
export const CELEBRITY_POSTERS_OFFSET_Y = getDPRSize(79);
export const CELEBRITY_POSTER_CORNER_RADIUS = getDPRSize(16);
export const CELEBRITY_POSTER_HEIGHT = getDPRSize(107);
export const CELEBRITY_POSTER_WIDTH = getDPRSize(80);
export const CELEBRITY_SUBTITLE_OFFSET_X = getDPRSize(112);
export const CELEBRITY_SUBTITLE_OFFSET_Y = getDPRSize(55);
export const CELEBRITY_TITLE_OFFSET_X =
  CELEBRITY_POSTER_WIDTH + CARTRIDGE_PADDING * 2;
export const CELEBRITY_TITLE_OFFSET_Y = getDPRSize(33);
export const GROUP_HEIGHT = BRAND_LOGO_OFFSET_Y - CARTRIDGE_GROUP_OFFSET_Y;
export const HEADER_LOGO_EXPORT_HEIGHT = getDPRSize(84);
export const HEADER_LOGO_EXPORT_WIDTH = getDPRSize(159);
export const HEADER_LOGO_OFFSET_Y = getDPRSize(83);
export const IMG_LIST_PADDING = getDPRSize(8);
export const INNER_BLOCK_WIDTH = BLOCKS_WIDTH - CARTRIDGE_PADDING * 2;
export const INNER_CELEBRITY_POSTERS_WIDTH =
  BLOCKS_WIDTH - CELEBRITY_POSTER_WIDTH - CARTRIDGE_PADDING;
export const LAYER_HEIGHT = getDPRSize(812);
export const LAYER_WIDTH = getDPRSize(375);
export const POSTER_CORNER_RADIUS = getDPRSize(7);
export const POSTER_HEIGHT = getDPRSize(64);
export const POSTER_MARGIN = getDPRSize(8);
export const POSTER_MAX = getDPRSize(5);
export const POSTER_WIDTH = getDPRSize(48);

export const SMALL_POSTER_HEIGHT = getDPRSize(61);
export const SMALL_POSTER_MARGIN = getDPRSize(8);
export const SMALL_POSTER_MAX = getDPRSize(3);
export const SMALL_POSTER_WIDTH = getDPRSize(46);
export const SUBTITLE_FONT_SIZE = getDPRSize(12);
export const SUBTITLE_LINE_HEIGHT = 16 / 12;
export const SUBTITLE_PADDING = getDPRSize(4);
export const TITLE_FONT_SIZE = getDPRSize(17);
export const TITLE_LINE_HEIGHT = 22 / 17;

// Flashback layout constants
export const FLASHBACK_COVER_LOGO_WIDTH = getDPRSize(72);
export const FLASHBACK_COVER_LOGO_HEIGHT = getDPRSize(47.25);
export const FLASHBACK_COVER_LOGO_TOP_MARGIN = getDPRSize(20);
export const FLASHBACK_COVER_LOGO_OPACITY = 1;
export const FLASHBACK_COVER_LOGO_SHADOW_OFFSET_Y = getDPRSize(0.436);
export const FLASHBACK_COVER_LOGO_SHADOW_BLUR = getDPRSize(0.654);

export const ALLOCINE_LOGO_WIDTH = getDPRSize(128);
export const ALLOCINE_LOGO_HEIGHT = getDPRSize(61.981);
export const ALLOCINE_LOGO_BOTTOM_MARGIN = getDPRSize(20);

export const SLIDE_CARD_WIDTH = getDPRSize(120);
export const SLIDE_CARD_HEIGHT = getDPRSize(160);
export const SLIDE_CARD_CORNER_RADIUS = getDPRSize(7);

// Flashback colors
export const FLASHBACK_BACKGROUND_COLOR = '#000000';
export const FLASHBACK_TEXT_COLOR = '#F2F2F2';
export const FLASHBACK_GOLDEN_GRADIENT = [
  0,
  '#FFDD00',
  0.5,
  '#FF9000',
  1,
  '#FF6600'
];

export const DEFAULT_FLASHBACK_LAYOUT_PROPS = {
  backgroundColor: FLASHBACK_BACKGROUND_COLOR,
  backgroundOpacity: 1,
  coverLogoWidth: FLASHBACK_COVER_LOGO_WIDTH,
  coverLogoHeight: FLASHBACK_COVER_LOGO_HEIGHT,
  coverLogoTopMargin: FLASHBACK_COVER_LOGO_TOP_MARGIN,
  coverLogoOpacity: FLASHBACK_COVER_LOGO_OPACITY,
  allocineLogoWidth: ALLOCINE_LOGO_WIDTH,
  allocineLogoHeight: ALLOCINE_LOGO_HEIGHT,
  allocineLogoBottomMargin: ALLOCINE_LOGO_BOTTOM_MARGIN
};

// Flashback viewing time screen constants
export const FLASHBACK_VIEWING_TIME_HOURS_FONT_SIZE = getDPRSize(84);
export const FLASHBACK_VIEWING_TIME_HOURS_FONT_WEIGHT = '900';
export const FLASHBACK_VIEWING_TIME_HOURS_LINE_HEIGHT = 1;

export const FLASHBACK_VIEWING_TIME_TEXT_FONT_SIZE = getDPRSize(38);
export const FLASHBACK_VIEWING_TIME_TEXT_FONT_WEIGHT = '600';
export const FLASHBACK_VIEWING_TIME_TEXT_LINE_HEIGHT = 1;

export const FLASHBACK_VIEWING_TIME_PHRASE_FONT_SIZE = getDPRSize(18);
export const FLASHBACK_VIEWING_TIME_PHRASE_FONT_WEIGHT = '500';
export const FLASHBACK_VIEWING_TIME_PHRASE_LINE_HEIGHT = 1.2;

export const FLASHBACK_VIEWING_TIME_POLAROID_WIDTH = getDPRSize(255);
export const FLASHBACK_VIEWING_TIME_POLAROID_ROTATION = -2;

export const FLASHBACK_FONT_FAMILY = 'Montserrat, Arial, sans-serif';

// Flashback repartition screen constants
export const FLASHBACK_REPARTITION_TITLE_FONT_SIZE = getDPRSize(18);
export const FLASHBACK_REPARTITION_TITLE_FONT_STYLE = '500';
export const FLASHBACK_REPARTITION_TITLE_LINE_HEIGHT = 1.2;

export const FLASHBACK_REPARTITION_MEMBER_CARD_WIDTH = getDPRSize(231);
export const FLASHBACK_REPARTITION_MEMBER_CARD_HEIGHT = getDPRSize(154);
export const FLASHBACK_REPARTITION_MEMBER_CARD_ROTATION = -2;
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_ROTATION = -0.8;
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_FONT_SIZE =
  getDPRSize(10);
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_FONT_STYLE = '600';
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_LINE_HEIGHT = 1;
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_OFFSET_X =
  getDPRSize(8);
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_OFFSET_Y =
  getDPRSize(52);
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_OFFSET_Y_EXTRA =
  getDPRSize(15);
export const FLASHBACK_REPARTITION_MEMBER_CARD_NICKNAME_FONT_FAMILY =
  'Permanent Marker, Arial, sans-serif';
export const FLASHBACK_REPARTITION_COVER_LOGO_TO_TITLE_SPACING = getDPRSize(50);
export const FLASHBACK_REPARTITION_TITLE_TO_CARD_SPACING = getDPRSize(50);
export const FLASHBACK_REPARTITION_GAUGE_TO_BOTTOM_LOGO_SPACING =
  getDPRSize(50);

export const FLASHBACK_REPARTITION_GAUGE_BAR_HEIGHT = getDPRSize(264.013);
export const FLASHBACK_REPARTITION_GAUGE_WIDTH = getDPRSize(280);
export const FLASHBACK_REPARTITION_GAUGE_COLUMN_WIDTH = getDPRSize(140);
export const FLASHBACK_REPARTITION_GAUGE_BAR_WIDTH = getDPRSize(140);
export const FLASHBACK_REPARTITION_GAUGE_BAR_CORNER_RADIUS = getDPRSize(32);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_WIDTH = getDPRSize(100.558);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_HEIGHT = getDPRSize(56.296);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_FONT_SIZE =
  getDPRSize(25);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_FONT_STYLE = '800';
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_FONT_FAMILY =
  'Montserrat, arial, sans-serif';
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_LINE_HEIGHT = 1;
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_TOP_MARGIN =
  getDPRSize(3);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_TEXT_FONT_SIZE = getDPRSize(15);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_TEXT_FONT_STYLE = '700';
export const FLASHBACK_REPARTITION_GAUGE_TICKET_TEXT_FONT_FAMILY =
  'Montserrat, arial, sans-serif';
export const FLASHBACK_REPARTITION_GAUGE_TICKET_TEXT_LINE_HEIGHT = 1;
export const FLASHBACK_REPARTITION_GAUGE_TICKET_COUNT_TO_LABEL_SPACING =
  getDPRSize(0);
export const FLASHBACK_REPARTITION_GAUGE_TICKET_ROTATION = 5;
export const FLASHBACK_REPARTITION_GAUGE_TICKET_TO_BAR_SPACING =
  getDPRSize(-10);
export const FLASHBACK_REPARTITION_MOVIE_COUNT_COLOR = '#222';
export const FLASHBACK_REPARTITION_MOVIE_LABEL_COLOR = '#222';
export const FLASHBACK_REPARTITION_SERIES_COUNT_COLOR = '#F2F2F2';
export const FLASHBACK_REPARTITION_SERIES_LABEL_COLOR = '#F2F2F2';

export const FLASHBACK_REPARTITION_MOVIE_BAR_COLOR_STOPS = [
  0,
  '#fc0',
  1,
  '#ff9000'
];
export const FLASHBACK_REPARTITION_SERIES_BAR_COLOR_STOPS = [
  0,
  '#5b75e6',
  1,
  '#422097'
];

// Flashback comparison screen constants
export const FLASHBACK_COMPARISON_TITLE_FONT_SIZE = getDPRSize(20);
export const FLASHBACK_COMPARISON_MESSAGE_2_FONT_SIZE = getDPRSize(17);
export const FLASHBACK_COMPARISON_TITLE_FONT_STYLE_1 = '700';
export const FLASHBACK_COMPARISON_TITLE_FONT_STYLE_2 = '500';
export const FLASHBACK_COMPARISON_TITLE_LINE_HEIGHT_1 = 25 / 20;
export const FLASHBACK_COMPARISON_TITLE_LINE_HEIGHT_2 = 22 / 20;

export const FLASHBACK_COMPARISON_LOGO_TO_MESSAGE_SPACING = getDPRSize(80);
export const FLASHBACK_COMPARISON_MESSAGE_1_TO_MESSAGE_2_SPACING =
  getDPRSize(50);
export const FLASHBACK_COMPARISON_MESSAGE_2_TO_CARD_SPACING = getDPRSize(15);

export const FLASHBACK_COMPARISON_CARD_WIDTH = getDPRSize(296);
export const FLASHBACK_COMPARISON_CARD_HEIGHT = getDPRSize(394);
export const FLASHBACK_COMPARISON_CARD_CORNER_RADIUS = getDPRSize(40);

export const FLASHBACK_COMPARISON_BADGE_WIDTH = getDPRSize(190);
export const FLASHBACK_COMPARISON_BADGE_HEIGHT = getDPRSize(61);
export const FLASHBACK_COMPARISON_BADGE_ROTATION = 5;
export const FLASHBACK_COMPARISON_BADGE_OFFSET_X = getDPRSize(50);
export const FLASHBACK_COMPARISON_BADGE_OFFSET_Y = getDPRSize(20);

// Flashback celebrity screen constants
export const FLASHBACK_CELEBRITY_POLAROID_WIDTH = getDPRSize(280);
export const FLASHBACK_CELEBRITY_POLAROID_HEIGHT = getDPRSize(408);
export const FLASHBACK_CELEBRITY_POLAROID_ROTATION = -2;
export const FLASHBACK_CELEBRITY_POLAROID_PADDING = getDPRSize(16);
export const FLASHBACK_CELEBRITY_POLAROID_CORNER_RADIUS = getDPRSize(8);
export const FLASHBACK_CELEBRITY_POLAROID_BACKGROUND_COLOR = '#F2F2F2';

export const FLASHBACK_CELEBRITY_IMAGE_WIDTH = getDPRSize(249);
export const FLASHBACK_CELEBRITY_IMAGE_HEIGHT = getDPRSize(326);
export const FLASHBACK_CELEBRITY_IMAGE_CORNER_RADIUS = getDPRSize(5);

export const FLASHBACK_CELEBRITY_BADGE_WIDTH = getDPRSize(95);
export const FLASHBACK_CELEBRITY_BADGE_HEIGHT = getDPRSize(120);
export const FLASHBACK_CELEBRITY_BADGE_ROTATION = 8;
export const FLASHBACK_CELEBRITY_BADGE_OFFSET_X = getDPRSize(-190);
export const FLASHBACK_CELEBRITY_BADGE_OFFSET_Y = getDPRSize(-170);
export const FLASHBACK_CELEBRITY_BADGE_CORNER_RADIUS = getDPRSize(12);

export const FLASHBACK_CELEBRITY_NAME_FONT_SIZE = getDPRSize(31.839);
export const FLASHBACK_CELEBRITY_NAME_FONT_STYLE = '900';
export const FLASHBACK_CELEBRITY_NAME_LINE_HEIGHT = 1;
export const FLASHBACK_CELEBRITY_NAME_COLOR = '#000000';
export const FLASHBACK_CELEBRITY_NAME_BACKGROUND_COLOR = '#FFFFFF';
export const FLASHBACK_CELEBRITY_NAME_PADDING = getDPRSize(5);
export const FLASHBACK_CELEBRITY_NAME_MARGIN_TOP = getDPRSize(-16);
export const FLASHBACK_CELEBRITY_NAME_SPACING = getDPRSize(8);

export const FLASHBACK_CELEBRITY_LOGO_TO_TITLE_SPACING = getDPRSize(50);
export const FLASHBACK_CELEBRITY_POLAROID_TO_BOTTOM_LOGO_SPACING =
  getDPRSize(50);

export const FLASHBACK_CELEBRITY_TITLE_FONT_SIZE = getDPRSize(50);
export const FLASHBACK_CELEBRITY_TITLE_FONT_STYLE = '900';
export const FLASHBACK_CELEBRITY_TITLE_LINE_HEIGHT = 1.2;
export const FLASHBACK_CELEBRITY_SUBTITLE_FONT_SIZE = getDPRSize(17);
export const FLASHBACK_CELEBRITY_SUBTITLE_FONT_STYLE = '500';
export const FLASHBACK_CELEBRITY_SUBTITLE_LINE_HEIGHT = 1.2;
export const FLASHBACK_CELEBRITY_TITLE_TO_SUBTITLE_SPACING = getDPRSize(8);
export const FLASHBACK_CELEBRITY_SUBTITLE_TO_POLAROID_SPACING = getDPRSize(40);

// Flashback user ranking screen constants
export const FLASHBACK_USER_RANKING_TITLE_FONT_SIZE = getDPRSize(28);
export const FLASHBACK_USER_RANKING_TITLE_FONT_WEIGHT = '800';
export const FLASHBACK_USER_RANKING_TITLE_LINE_HEIGHT = 1;
export const FLASHBACK_USER_RANKING_TITLE_COLOR = '#E0E0E0';

export const FLASHBACK_USER_RANKING_SUBTITLE_FONT_SIZE = getDPRSize(17);
export const FLASHBACK_USER_RANKING_SUBTITLE_FONT_WEIGHT = '500';
export const FLASHBACK_USER_RANKING_SUBTITLE_LINE_HEIGHT = 1.2;
export const FLASHBACK_USER_RANKING_SUBTITLE_COLOR = '#E0E0E0';

export const FLASHBACK_USER_RANKING_LORD_IMAGE_WIDTH = getDPRSize(151);
export const FLASHBACK_USER_RANKING_LORD_IMAGE_HEIGHT = getDPRSize(137);
export const FLASHBACK_USER_RANKING_PERCENT_IMAGE_WIDTH = getDPRSize(192);
export const FLASHBACK_USER_RANKING_PERCENT_IMAGE_HEIGHT = getDPRSize(220);
export const FLASHBACK_USER_RANKING_PERCENT_IMAGE_CORNER_RADIUS =
  getDPRSize(12);
export const FLASHBACK_USER_RANKING_LOGO_TO_LORD_IMAGE_SPACING = getDPRSize(90);
export const FLASHBACK_USER_RANKING_LORD_IMAGE_TO_TITLE_SPACING =
  getDPRSize(30);
export const FLASHBACK_USER_RANKING_TITLE_TO_SUBTITLE_SPACING = getDPRSize(30);
export const FLASHBACK_USER_RANKING_SUBTITLE_TO_PERCENT_IMAGE_SPACING =
  getDPRSize(80);

// Flashback bilan user screen constants
export const FLASHBACK_BILAN_HOURS_FONT_SIZE = getDPRSize(52);
export const FLASHBACK_BILAN_HOURS_FONT_WEIGHT = '700';
export const FLASHBACK_BILAN_HOURS_LINE_HEIGHT = 1;

export const FLASHBACK_BILAN_HOURS_TEXT_FONT_SIZE = getDPRSize(20);
export const FLASHBACK_BILAN_HOURS_TEXT_FONT_WEIGHT = '700';
export const FLASHBACK_BILAN_HOURS_TEXT_LINE_HEIGHT = 1;

export const FLASHBACK_BILAN_POLAROID_WIDTH = getDPRSize(250);
export const FLASHBACK_BILAN_POLAROID_HEIGHT = getDPRSize(281);
export const FLASHBACK_BILAN_POLAROID_ROTATION = 0;

export const FLASHBACK_BILAN_COMPARISON_BADGE_WIDTH = getDPRSize(162);
export const FLASHBACK_BILAN_COMPARISON_BADGE_ROTATION = 8;
export const FLASHBACK_BILAN_COMPARISON_BADGE_OFFSET_X = getDPRSize(-40);
export const FLASHBACK_BILAN_COMPARISON_BADGE_OFFSET_Y = getDPRSize(2);

export const FLASHBACK_BILAN_MEMBER_CARD_WIDTH = getDPRSize(231);
export const FLASHBACK_BILAN_MEMBER_CARD_HEIGHT = getDPRSize(154);
export const FLASHBACK_BILAN_MEMBER_CARD_ROTATION = -2;

export const FLASHBACK_BILAN_POLAROID_BADGE_WIDTH = getDPRSize(72);
export const FLASHBACK_BILAN_POLAROID_BADGE_HEIGHT = getDPRSize(88);
export const FLASHBACK_BILAN_POLAROID_BADGE_ROTATION = 3;
export const FLASHBACK_BILAN_POLAROID_BADGE_OFFSET_X = getDPRSize(100);
export const FLASHBACK_BILAN_POLAROID_BADGE_OFFSET_Y = getDPRSize(90);

export const FLASHBACK_BILAN_THANKS_BADGE_WIDTH = getDPRSize(67);
export const FLASHBACK_BILAN_THANKS_BADGE_HEIGHT = getDPRSize(67);
export const FLASHBACK_BILAN_THANKS_BADGE_ROTATION = -10;
export const FLASHBACK_BILAN_THANKS_BADGE_OFFSET_X = getDPRSize(100);
export const FLASHBACK_BILAN_THANKS_BADGE_OFFSET_Y = getDPRSize(40);

export const FLASHBACK_BILAN_HOURS_TO_TEXT_SPACING = getDPRSize(5);
export const FLASHBACK_BILAN_TEXT_TO_IMAGES_SPACING = getDPRSize(40);
export const FLASHBACK_BILAN_IMAGES_SPACING = getDPRSize(30);

// Flashback podium screen constants
export const FLASHBACK_PODIUM_TITLE_FONT_SIZE = getDPRSize(50);
export const FLASHBACK_PODIUM_TITLE_FONT_WEIGHT = '900';
export const FLASHBACK_PODIUM_TITLE_LINE_HEIGHT = 1;

export const FLASHBACK_PODIUM_SUBTITLE_FONT_SIZE = getDPRSize(17);
export const FLASHBACK_PODIUM_SUBTITLE_FONT_WEIGHT = '500';
export const FLASHBACK_PODIUM_SUBTITLE_LINE_HEIGHT = 1.2;
export const FLASHBACK_PODIUM_TITLE_TO_SUBTITLE_SPACING = getDPRSize(8);

export const FLASHBACK_PODIUM_LOGO_TO_TITLE_SPACING = getDPRSize(35);
export const FLASHBACK_PODIUM_TITLE_TO_CARDS_SPACING = getDPRSize(150);

export const FLASHBACK_PODIUM_CARD_1_WIDTH = getDPRSize(242);
export const FLASHBACK_PODIUM_CARD_1_HEIGHT = getDPRSize(323);
export const FLASHBACK_PODIUM_CARD_2_3_WIDTH = getDPRSize(150);
export const FLASHBACK_PODIUM_CARD_2_3_HEIGHT = getDPRSize(200);
export const FLASHBACK_PODIUM_CARD_CORNER_RADIUS = getDPRSize(24);

export const FLASHBACK_PODIUM_CARD_2_TRANSLATE_X = getDPRSize(-80);
export const FLASHBACK_PODIUM_CARD_2_ROTATION = -5;

export const FLASHBACK_PODIUM_CARD_3_TRANSLATE_X = getDPRSize(85);
export const FLASHBACK_PODIUM_CARD_3_TRANSLATE_Y = getDPRSize(120);
export const FLASHBACK_PODIUM_CARD_3_ROTATION = 5;

export const FLASHBACK_PODIUM_BADGE_WIDTH = getDPRSize(72);
export const FLASHBACK_PODIUM_BADGE_HEIGHT = getDPRSize(72);
export const FLASHBACK_PODIUM_BADGE_1_WIDTH = getDPRSize(72);
export const FLASHBACK_PODIUM_BADGE_1_HEIGHT = getDPRSize(72);

export const FLASHBACK_PODIUM_BADGE_1_OFFSET_X = getDPRSize(-80);
export const FLASHBACK_PODIUM_BADGE_1_OFFSET_Y = getDPRSize(35);
export const FLASHBACK_PODIUM_BADGE_2_OFFSET_X = getDPRSize(60);
export const FLASHBACK_PODIUM_BADGE_2_OFFSET_Y = getDPRSize(220);
export const FLASHBACK_PODIUM_BADGE_3_OFFSET_X = getDPRSize(10);
export const FLASHBACK_PODIUM_BADGE_3_OFFSET_Y = getDPRSize(-20);

export const FLASHBACK_PODIUM_RANK_FONT_SIZE = getDPRSize(37);
export const FLASHBACK_PODIUM_RANK_FONT_WEIGHT = '900';
export const FLASHBACK_PODIUM_RANK_COLOR = '#1A1A1A';
